var map = {
	"./admiav2atar1.jpg": 5229,
	"./admiav32atar1.jpg": 8156,
	"./admiavatar.jpg": 4417,
	"./admiavatar1.jpg": 210,
	"./avatar.jpg": 9389,
	"./bg-leftbar.jpg": 6143,
	"./logistImage.jpg": 9958,
	"./managerImage.jpg": 9583,
	"./masterImage.jpg": 2108,
	"./u20_7rY2vv.jpg": 8073,
	"./u23.jpg": 6757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;